'use client';
import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import UserOnboardingForm from '@/app/_components/onboarding/onboardingSplash/form';

interface Props {
  isOpen: boolean;
  onClose: (data: any) => void;
}

const OnboardingSplash = ({ isOpen, onClose }: Props) => {
  return (
    <Transition show={isOpen}>
      <Dialog
        as="div"
        className="fixed top-0 left-0 z-[60] h-screen w-full bg-purple9 overflow-y-auto"
        onClose={() => {}}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <Dialog.Panel>
            <UserOnboardingForm onClose={onClose} />
          </Dialog.Panel>
        </Transition.Child>
      </Dialog>
    </Transition>
  );
};

export default OnboardingSplash;
